module.exports = __webpack_public_path__ + "img/blankQrCode.e8c72734.png";